export { default } from '../src/page-thanks';
